import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { ImagePipe } from 'src/app/pipes/image/image';
import { EnqueteProvider } from 'src/app/services/enquete/enquete';
import { UserProvider } from 'src/app/services/user/user';
@Component({
  selector: 'app-enquete-resultado',
  templateUrl: './enquete-resultado.page.html',
  styleUrls: ['./enquete-resultado.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    CommonModule,
    TranslateModule,
    LoadingSpinnerComponent,
  ],
})
export class EnqueteResultadoPage implements OnInit {
  idEnquete: any;
  enquete: any = {};
  perguntas: any = [];
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public userProvider: UserProvider,
    public enqueteProvider: EnqueteProvider,
    public navParams: NavParams,
    public modalCtrl: ModalController
  ) {
    this.idEnquete = this.navParams.get('idEnquete');
    this.enqueteProvider.resumoEnquete(this.idEnquete).subscribe((data) => {
      this.enquete = data.enquete;
      this.perguntas = data.perguntas;

      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss({acabou: true});
  }
}
